var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("d2-container", { attrs: { type: "card" } }, [
    _c("p", [_vm._v("src/views/demo/playground/add-routes/alternates/1.vue")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }